import { Flex } from "@chakra-ui/react";
import { Header } from "components/Header";
import PaginationComp from "components/PaginationComp";
import TableList from "components/TableList";
import { toaster } from "components/ui/toaster";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "services/api";

const headers = ["Account"];

function CommissionRules() {
  const [isLoading, setIsLoading] = useState(false);
  const [list, setList] = useState([]);
  // const [selectedItem, setSelectedItem] = useState();
  const [activePage, setActivePage] = useState(1);

  const navigate = useNavigate();

  const getList = async (data) => {
    setIsLoading(true);
    api
      .getCommissionsheetRegMan({
        page: data?.page || activePage,
      })
      .then((res) => {
        setIsLoading(false);
        if (res?.status === 200) {
          console.log("getRegionalManagers = ", res?.data);
          if (res?.data && res?.data[0]?.userid) {
            if (data?.page) {
              setActivePage(data?.page);
            }
            const l = res.data.map((a, index) => ({
              id: `reg-man-${index}`,
              // value: `${a.companyname}-${index}`,
              label: a.companyname,
              data: a,
            }));
            setList(l);
          } else {
            setList([]);
          }
        } else {
          setList([]);
          toaster.create({
            title: res?.message,
            type: "error",
          });
        }
      });
    return;
    // api
    //   .getGroups({
    //     page: data?.page || 1,
    //   })
    //   .then((res) => {
    //     setIsLoading(false);
    //     console.log("getList", res);

    //     if (res?.status === 200) {
    //       if (data?.page) {
    //         setActivePage(data.page);
    //       }
    //       if (res?.data && res?.data[0]) {
    //         const l = res.data.map((item, index) => ({
    //           id: `groups-${index}`,
    //           groups: item?.groupname || "",
    //           data: item,
    //         }));

    //         setList(l);
    //       } else {
    //         setList([]);
    //       }
    //     } else {
    //       setList([]);
    //       toaster.create({
    //         title: res?.message,
    //         type: "error",
    //       });
    //     }
    //   });
  };

  const onChangePage = (data) => {
    if (data?.page === activePage) {
      return;
    }
    getList({
      page: data.page,
      // limitId: utils.getLimitId(filerLast),
      // searchTxt: searchTxt,
      // dealerid: utils.getDealerid(dealers),
    });
  };

  const onOpen = (data) => {
    navigate("/commissionrulesview", {
      state: {
        action: "commissionrulesview-edit",
        data: data?.item?.data,
      },
    });
  };

  const onSelectItm = (data) => {
    onOpen(data);
  };

  useEffect(() => {
    getList();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Flex flex={1} overflow={"hidden"} direction={"column"} p={"2rem"}>
      <Header label={"Commission Rules"} isLoading={isLoading} />
      <TableList
        type={"simple"}
        headers={headers}
        items={list}
        onSelect={onSelectItm}
        // selectedItem={selectedItem}
      />
      <PaginationComp
        // pageSize={10}
        itemsLength={list?.length}
        activePage={activePage}
        onChange={onChangePage}
      />
    </Flex>
  );
}

export default CommissionRules;
